module.exports = __webpack_public_path__ + "img/67.9d6f8ba4.png";